const L = "LOCALHOST", o = "PROD", t = "STG", O = {
  LOCALHOST: L,
  PROD: o,
  STG: t
}, c = "NATIVE", n = "SERVER", s = "WEB", T = {
  NATIVE: c,
  SERVER: n,
  WEB: s
}, E = "LOGIN", A = "PAYWALL", R = {
  LOGIN: E,
  PAYWALL: A
};
export {
  O as ENVIRONMENT,
  L as LOCALHOST,
  E as LOGIN,
  c as NATIVE,
  A as PAYWALL,
  T as PLATFORM,
  o as PROD,
  n as SERVER,
  t as STG,
  R as WALL_TYPE,
  s as WEB
};
